{
  "loginForm": {
    "button": {
      "create": "loginForm.button.create",
      "forgot": "Send",
      "login": "Login",
      "reset": "loginForm.button.reset",
      "update": "loginForm.button.update"
    },
    "header": {
      "create": "loginForm.header.create",
      "forgot": "Forgot password",
      "login": "Welcome Back",
      "reset": "loginForm.header.reset",
      "update": "loginForm.header.update"
    },
    "label": {
      "create": "Create today!",
      "createPrefix": "Don't have an account?",
      "email": "Email",
      "forgotPassword": "Forgot your password?",
      "password": "Password",
      "rememberMe": "Remember me",
      "username": "Username"
    }
  }
}
